/** CasaMapa internal admin portal — aligned with public CasaMapa locale and currency preferences. */
export const CASAMAPA_ADMIN_PORTAL_I18N_MANIFEST = {
  market: { code: "CO" },
  i18n: {
    defaultLocale: "es-CO",
    supportedLocales: ["es-CO", "en-US"],
    defaultCurrency: "COP",
    supportedCurrencies: ["COP", "USD", "EUR"],
  },
};
